export default __webpack_public_path__ + "static/media/login-bg-46.f1bc2011.jpg";